import { NgModule }           from '@angular/core';
import { FormsModule, ReactiveFormsModule }    from '@angular/forms';
import { CommonModule }        from '@angular/common';

//import map specific stuff
import { MapComponent } from './map.component';
import { MapViewComponent } from './mapview.component';
import { MapService } from './map.service';

//import the shared functionality module
import { SharedModule }   from '../../shared/shared.module';
import { LocationSearchModule }  from '../../location-search/locationsearch.module';

@NgModule({
  imports:      [
    SharedModule,
    LocationSearchModule
  ],
  declarations: [ MapComponent, MapViewComponent ],
  providers:    [ MapService ],
  exports: [ MapComponent, MapViewComponent ]
})
export class MapInfoModule { }


// WEBPACK FOOTER //
// ./app/information/map/mapinfo.module.ts